// StyledRadioButton.js
import styled from "styled-components";

const StyledRadioButton = styled.input.attrs({ type: "radio" })`
  opacity: 0;
  position: absolute;

  & + label {
    display: inline-block;
    vertical-align: middle;
    margin: 5px;
    cursor: pointer;
    width: fit-content;
    display: flex !important;
    position: relative;
    margin-left: 0px !important;
    align-items: center;

    &:before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      padding: 0px;
      margin-right: 10px;
      border-style: solid;
      font-size: ${({ styling }) => `${styling.radioInputSize - 3}px`};
      width: ${({ styling }) => `${styling.radioInputSize}px`};
      height: ${({ styling }) => `${styling.radioInputSize}px`};
      border-color: ${({ styling }) => styling.radioUncheckedBorderColor};
      border-width: ${({ styling }) => `${styling.radioBorderWidth}px`};
      background: ${({ styling }) => styling.radioUncheckedBackgroundColor};
      border-radius: ${({ styling }) => `${styling.radioBorderRadius}px`};
      transition: ${(props) => props.theme.transitionMain};
    }
  }

  &:checked + label:before {
    background: ${({ styling }) => styling.radioCheckedBackgroundColor};
    border-color: ${({ styling }) => styling.radioCheckedBorderColor};
  }
`;

export default StyledRadioButton;
